import { TechDocPage } from '../containers/pages';
import { PRIMERA_VIDEO_URL } from '../constants';

export const powerupInit = [
  {
    path: '/powerup-init',
    menuText: 'powerUpAndInit',
    exact: true,
    redirectTo: '/powerup-init/powerUp',
    submenuItems: [
      {
        path: '/powerup-init/powerUp',
        menuText: 'powerUp',
        exact: true,
        component: TechDocPage,
        pageProps: {
          videoUrl: PRIMERA_VIDEO_URL.POWERUPANDINIT_POWER,
        },
      },
      {
        path: '/powerup-init/prerequisites',
        menuText: 'prerequisites',
        exact: true,
        component: TechDocPage,
        pageProps: {},
      },
      {
        path: '/powerup-init/initialize',
        menuText: 'initialize',
        exact: true,
        component: TechDocPage,
        pageProps: {
          contentType: 'react-showdown',
          videoUrl: PRIMERA_VIDEO_URL.POWERUPANDINIT_INIT,
        },
      },
      {
        path: '/powerup-init/cloudEnable',
        menuText: 'cloudEnable',
        exact: true,
        component: TechDocPage,
        pageProps: {},
      },
      {
        path: '/powerup-init/addAndAssignArray',
        menuText: 'addAndAssignArray',
        exact: true,
        component: TechDocPage,
        pageProps: {},
      },
      {
        path: '/powerup-init/completeSetup',
        menuText: 'setupComplete',
        exact: true,
        component: TechDocPage,
        pageProps: {},
      },
    ],
  },
];
